import { render, staticRenderFns } from "./BatchDetail.vue?vue&type=template&id=0d4329c7&"
import script from "./BatchDetail.vue?vue&type=script&lang=ts&"
export * from "./BatchDetail.vue?vue&type=script&lang=ts&"
import style0 from "./BatchDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports